import React from 'react'

import { fetch_ad_id, qps_from_search } from '../../helpers/misc'
import LoadingBar from '../Shared/LoadingBar'
import { useFetchApi } from '../Shared/hooks'
import AlertResultCL from './ResultCL'

const AlertResultCF = ({ location, match }) => {
  const fetcher = useFetchApi()
  const [ad, set_ad] = React.useState(null)
  const qps = qps_from_search(location.search)
  const ad_id = match.params.id
  const alert_id = qps.token || ''

  React.useEffect(() => {
    const _fetch = async () => {
      const res = await fetch_ad_id(fetcher, ad_id)
      set_ad(res.ad)
    }

    _fetch()
  }, [ad_id, fetcher])

  if (ad) {
    return (
      <AlertResultCL
        ad={ad}
        linkContact={`/alert_result_view_ad?ad=${ad_id}&alert_token=${alert_id}`}
      />
    )
  }

  return <LoadingBar />
}

export default AlertResultCF
